import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Validate that a URL uses a safe scheme (http/https) before rendering in href.
// Returns "#" for javascript:, data:, or any other dangerous scheme.
export function safeUrl(url: string): string {
  if (!url || url === "#") return "#";
  try {
    const parsed = new URL(url);
    if (parsed.protocol === "https:" || parsed.protocol === "http:") return url;
  } catch {}
  return "#";
}

// Sanitize user-provided search queries before sending them to the backend.
// Removes special characters that could interfere with the API and trims
// extra whitespace.
export function sanitizeSearchQuery(query: string): string {
  return query.replace(/[^\w\s-]/g, "").trim();
}

// Format a price for display. Frontend products in this repo store price in
// pence (integer); the Worker payload for saved pieces stores it in major
// units (REAL). Callers pass the already-major-unit number; only the
// currency symbol is parameterised.
export function formatPrice(
  price: number | null | undefined,
  currency: string | null = "GBP",
): string | null {
  if (price == null || isNaN(price)) return null;
  const symbol = currency === "GBP" || !currency ? "£" : "";
  return `${symbol}${price.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}
